import React from 'react';
import { useAuth } from '../../context/AuthContext';
import DashboardTile from '../DashboardTile';

const TILES = [
  { title: 'Consultations',      icon: '💬', description: 'Manage community consultation projects',    path: '/consultation',   color: '#4285F4' },
  { title: 'Community Data',     icon: '📂', description: 'Review and manage community data entries',  path: '/community-data', color: '#0F9D58' },
  { title: 'Harvesting',         icon: '🌾', description: 'Harvesting reports, maps and log entries',  path: '/harvesting',     color: '#DB4437' },
  { title: 'Lenses',             icon: '🔭', description: 'Intelligence lenses and framework views',   path: '/lenses',         color: '#9C27B0' },
  { title: '7 Generation Plan',  icon: '🌀', description: 'Long-range planning and assessment',        path: '/seven-gen',      color: '#FF5722' },
  { title: 'Assessments',        icon: '🧭', description: 'Review and score project assessments',      path: '/assessments',    color: '#F4B400' },
  { title: 'Reports',            icon: '📊', description: 'Generated platform reports',                path: '/reports',        color: '#00BCD4' },
  { title: 'Pipeline',           icon: '⚙️', description: 'Data pipeline and export management',       path: '/pipeline',       color: '#607D8B' },
  { title: 'Land Intelligence',  icon: '🗺️', description: 'Land unit assessments and evaluations',     path: '/land-units',     color: '#8BC34A' },
  { title: 'Land Values',        icon: '📐', description: 'Community land values and criteria',        path: '/land-values',    color: '#795548' },
];

const StaffDashboard = () => {
  const { user } = useAuth();

  return (
    <div className="panel-dashboard">
      <div className="panel-dashboard__header">
        <div>
          <h1>Staff Dashboard</h1>
          <p>Welcome, {user?.firstName || user?.email} — CIP staff</p>
        </div>
      </div>

      <h2 className="panel-dashboard__section-title">Platform Modules</h2>
      <div className="tile-grid">
        {TILES.map((t) => <DashboardTile key={t.title} {...t} />)}
      </div>
    </div>
  );
};

export default StaffDashboard;
